import { getListData } from './getListData.ts';

export const getInitialData = (data: string[]) => {
  const listData = getListData(data);

  return {
    bulkInput: '',
    textareaDisabled: false,
    listData,
    validItems: [],
    bulkErrors: [],
  };
};
